import { Controller } from "@hotwired/stimulus"

// Toggles a small set of classes on a <select> based on its current
// value. Used by the todo inline editor's status select so the "pill"
// color stays in sync with the chosen status without needing the server
// to re-render the form (which auto-save deliberately skips so the user
// keeps focus while editing).
//
// The value-to-class map is read from a JSON object on
// `data-status-pill-classes-value`. The element's classList is updated
// in place: classes from any *other* mapped state are stripped and the
// classes for the current state are added.
//
// Example:
//   <select data-controller="status-pill"
//           data-action="change->status-pill#update"
//           data-status-pill-classes-value='{"done":"bg-green-700 ...", "in_progress":"bg-blue-700 ...","not_started":"bg-gray-700 ..."}'>
//     ...
//   </select>
export default class extends Controller {
  static values = {
    classes: { type: Object, default: {} }
  }

  connect() {
    this.update()
  }

  update() {
    const map = this.classesValue || {}
    const current = this.element.value
    Object.entries(map).forEach(([state, cls]) => {
      const tokens = cls.split(/\s+/).filter(Boolean)
      if (state === current) {
        this.element.classList.add(...tokens)
      } else {
        this.element.classList.remove(...tokens)
      }
    })
  }
}
